exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-reports[data-v-3f9c54fb]{overflow-x:auto}.table-reports[data-v-3f9c54fb]:empty{display:none}tr td[data-v-3f9c54fb]:first-child{min-width:300px}.table-reports[data-v-3f9c54fb]{overflow-x:scroll;max-width:100%}.table-reports tr td[data-v-3f9c54fb]{padding:8px;min-width:95px}.table-reports tr td[data-v-3f9c54fb]:first-child{min-width:210px}", ""]);

// exports
